"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OfferFieldJobArea = OfferFieldJobArea;
const jsx_runtime_1 = require("react/jsx-runtime");
const job_area_select_field_1 = require("@src/components/modules/forms/job-area-select-field");
const types_1 = require("@src/types");
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
function OfferFieldJobArea() {
    const intl = (0, react_intl_1.useIntl)();
    return ((0, jsx_runtime_1.jsx)(job_area_select_field_1.JobAreaSelectField, { rules: [
            {
                required: true,
                message: intl.formatMessage({
                    id: 'admin.offer_validation.please_select_at_least_one_trend',
                }),
            },
        ], label: intl.formatMessage({
            id: 'admin.offer_form.choose_job_area',
        }), name: types_1.EOfferBasicInfoFormField.jobArea, useIdAsValue: false, maxTagCount: 'responsive' }));
}
